/* eslint-disable no-empty */
import AuthRequests from '../../server/auth';
import PermissionsServer from '../../server/permissions';
import Settings from '../../server/settings';
import UsersRequests from '../../server/users';
import AuthService from '../../services/auth';
import { addLoading, removeLoading } from './loading';

export const setAuth = (auth) => ({
  type: 'SET_APP_AUTH',
  auth,
});

export const setUser = (user) => ({
  type: 'SET_USER_lOGGED',
  user,
});

export const setUserMenus = (menus) => ({
  type: 'SET_USER_MENUS',
  menus,
});

export const setUserRoutes = (routes) => ({
  type: 'SET_USER_ROUTES',
  routes,
});

export const setUserProgramList = (programList) => ({
  type: 'SET_USER_PROGRAM_LIST',
  programList,
});

export const setUserFavoriteList = (favoriteList) => ({
  type: 'SET_USER_FAVORITE_LIST',
  favoriteList,
});

export const setUserPermissions = (permissions) => ({
  type: 'SET_USER_PERMISSIONS',
  permissions,
});

export const setUserPermissionsCompany = (permissionsCompany) => ({
  type: 'SET_USER_PERMISSIONS_COMPANY',
  permissionsCompany,
});

export const setCronLocation = (cronLocation) => ({
  type: 'SET_USER_CRON_LOCATION',
  cronLocation,
});

export const setAppLocale = (locale) => ({
  type: 'SET_USER_LOCALE',
  locale,
});

export const setAppTimezone = (timezone) => ({
  type: 'SET_USER_TIMEZONE',
  timezone,
});

export const setNotifications = (notifications) => ({
  type: 'SET_USER_NOTIFICATIONS',
  notifications,
});

export const setBranchUser = (branchUser) => ({
  type: 'SET_BRANCH_USER',
  branchUser,
});

export const setBeeWikiHost = (beeWikiHost) => ({
  type: 'SET_BEE_WIKI_HOST',
  beeWikiHost,
});

export const getAllPermissions = () => async (dispatch) => {
  try {
    const permissions = await PermissionsServer.getAll();
    const beeWikiHost = await Settings.getBeeWikiHost();
    dispatch(setBranchUser(permissions.branchUser));
    dispatch(setBeeWikiHost(beeWikiHost));
    if (permissions.menus) await dispatch(setUserMenus(permissions.menus));
    if (permissions.permissions) await dispatch(setUserPermissions(permissions.permissions));
    if (permissions.permissionsCompany) await dispatch(setUserPermissionsCompany(permissions.permissionsCompany));
    if (permissions.routes) await dispatch(setUserRoutes(permissions.routes));
    if (permissions.programList) await dispatch(setUserProgramList(permissions.programList));
    if (permissions.favoriteList) await dispatch(setUserFavoriteList(permissions.favoriteList));
  } catch (e) {}
};

export const authenticate = (username, password) => async (dispatch) => {
  try {
    dispatch(addLoading(true));
    const auth = await AuthRequests.authenticate(username, password);
    AuthService.create(auth);
    await dispatch(setAuth(auth));
    await dispatch(getAllPermissions());
  } finally {
    dispatch(removeLoading(false));
  }
};

export const refreshToken = (token) => async (dispatch) => {
  try {
    const auth = await AuthRequests.refreshToken(token);
    AuthService.create(auth);
    dispatch(setAuth(auth));
  } finally {}
};

export const getUserLogged = () => async (dispatch) => {
  try {
    const user = await AuthRequests.getUserLogged();
    if (user) {
      dispatch(setUser(user));
    }
  } finally {}
};

export const changeMainBranch = (mainBranch) => async (dispatch) => {
  try {
    dispatch(addLoading(true));
    await UsersRequests.updateMainBranch(mainBranch);
    await dispatch(getUserLogged());
    await dispatch(getAllPermissions());
    document.location.reload();
  } finally {
    dispatch(removeLoading(false));
  }
};

export const logout = () => async (dispatch) => {
  try {
    await AuthRequests.logout();
    AuthService.reset();
    dispatch(setAuth({}));
  } finally {}
};
